<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
				<div class="page-header clearfix">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<router-link data-toggle="tooltip" title="Назад" class="btn btn-default" to="/link/list"><i class="fa fa-arrow-left"></i></router-link>
					<router-link data-toggle="tooltip" title="Редактирай" class="btn btn-info" :to="'/link/' + link.id + '/edit'" v-if="canEdit"><i class="fa fa-pencil"></i></router-link>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid" v-if="dataReady">
		<div class="card">
			<div class="card-header clearfix">
				<h4 class="card-title pull-left">
					{{ link.title }}
				</h4>
				<a :href="link.link" class="btn btn-primary btn-icon pull-right" target="_blank"><i class="fa fa-file-text"></i> Отвори</a>
			</div>
			<div class="card-block">
				<p style="white-space: pre-line">
					<strong>Описание:</strong>
					{{ link.description }}
				</p>
				<hr>
				<p>
					<strong>Предоставен от:</strong>
					<div class="clearfix">
						<c-avatar v-for="family in link.families" :family="family" class="float-left"></c-avatar>
					</div>
				</p>
			</div>
		</div><!--	end card	-->
	</div>
</div>
</template>

<script>

module.exports = {
	data: function () {
		return {
			dataReady: false,
			link: {}
		};
	},
	created: function () {
		this.fetchData();
	},
	computed: {
		canEdit: function () {
			if (!this.link.families) return false;
			for (var i = 0; i < this.link.families.length; i++) {
				if (this.link.families[i].id + '' === this.$user.familyUser.family.id + '') {
					return true;
				}
			}
			return false;
		}
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function () {
			this.$http.get('backend://link/' + this.$route.params.id).then((result) => {
				this.link = result.body;
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		}
	}
};

</script>
<style>

</style>



// WEBPACK FOOTER //
// LinkView.vue?f8a1d6e6